import Typography from '@mui/material/Typography';
import React from 'react';

import * as Styled from './popup-menu.style';
import { Colors } from './types';

export type PopupMenuTitleProps = {
  title: string;
  end?: React.ReactNode;
  isSubTitle?: boolean;
  hasBottomBorder?: boolean;
  compact?: boolean;
};

export const PopupMenuTitle: React.FC<PopupMenuTitleProps> = ({
  title,
  end,
  isSubTitle,
  hasBottomBorder,
  compact,
}) => (
  <Styled.TitleContainer
    $color={isSubTitle ? Colors.TextSecondary : undefined}
    $hasBottomBorder={!!hasBottomBorder}
    $compact={!!compact}
  >
    <Typography variant={isSubTitle ? 'caption' : 'subtitle2'}>
      {title}
    </Typography>
    {end}
  </Styled.TitleContainer>
);
